// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EntityEditor__entityEditorContainer___1ZgR3{background:white;display:flex;flex-direction:column;height:80vh;overflow-y:scroll}.EntityEditor__entityEditorContainerTabs___2I-kE-item{padding:8px 18px}.EntityEditor__alertWarning___1a8jF{padding:15px;color:#856404;background-color:#fff3cd;border-color:#ffeeba;display:flex}.EntityEditor__alertWarning___1a8jF g{stroke:#856404}.EntityEditor__bodyContainer___3dqks{display:flex;flex:1;flex-direction:column;overflow-y:auto}.EntityEditor__modalActionables___eyUjl{display:flex}.EntityEditor__modalActionables___eyUjl>*{margin-left:5px}.EntityEditor__botResponseContainer___dtLyK{padding:10px;background-color:#eeeeef}\n", ""]);
// Exports
exports.locals = {
	"entityEditorContainer": "EntityEditor__entityEditorContainer___1ZgR3",
	"entityEditorContainerTabs": "EntityEditor__entityEditorContainerTabs___2I-kE",
	"alertWarning": "EntityEditor__alertWarning___1a8jF",
	"bodyContainer": "EntityEditor__bodyContainer___3dqks",
	"modalActionables": "EntityEditor__modalActionables___eyUjl",
	"botResponseContainer": "EntityEditor__botResponseContainer___dtLyK"
};
module.exports = exports;
